export default __webpack_public_path__ + "static/media/whac-a-matt.e706f615.jpg";